export const Cat = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.0756 6.417L17.4649 4.3697C17.9209 3.97897 18.5627 3.88943 19.1082 4.1404C19.6538 4.39137 20.0033 4.93695 20.0033 5.53746V13.0004C20.0033 17.4206 16.4201 21.0038 12 21.0038V21.0038C7.57986 21.0038 3.99664 17.4206 3.99664 13.0004V5.53746C3.99664 4.93695 4.3462 4.39137 4.89174 4.1404C5.43729 3.88943 6.07902 3.97897 6.53503 4.3697L8.92438 6.417C10.9144 5.71342 13.0855 5.71342 15.0756 6.417Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.2493 10.7498C10.2491 10.8878 10.1371 10.9996 9.99906 10.9996C9.86102 10.9995 9.74913 10.8876 9.74907 10.7496C9.74901 10.6115 9.86081 10.4995 9.99885 10.4994C10.0653 10.4993 10.129 10.5256 10.176 10.5726C10.223 10.6196 10.2494 10.6834 10.2493 10.7498"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.2509 10.7498C14.2507 10.8878 14.1388 10.9996 14.0007 10.9996C13.8627 10.9995 13.7508 10.8876 13.7507 10.7496C13.7507 10.6115 13.8625 10.4995 14.0005 10.4994C14.0669 10.4993 14.1307 10.5256 14.1777 10.5726C14.2247 10.6196 14.251 10.6834 14.2509 10.7498"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 14.501V14.501C11.7237 14.501 11.4998 14.277 11.4998 14.0008V14.0008C11.4998 13.9087 11.5744 13.834 11.6665 13.834H12.3335C12.4255 13.834 12.5002 13.9087 12.5002 14.0008V14.0008C12.5002 14.277 12.2762 14.501 12 14.501Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.81226 17.1269C10.0524 17.3676 10.3785 17.5027 10.7185 17.5022V17.5022C11.4262 17.5022 12 16.9285 12 16.2207C12 16.739 12.3122 17.2063 12.7911 17.4047C13.27 17.603 13.8212 17.4934 14.1877 17.1269"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 14.501V16.2207"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.0021 12.8069L21.0037 12.14"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.0037 16.0017L17.0021 15.3347"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.99788 12.8069L2.99622 12.14"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.99622 16.0017L6.99788 15.3347"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Cat</div>
    </div>
  );
};

export const Dog = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 13.6674V13.6674C11.7237 13.6674 11.4998 13.4434 11.4998 13.1672V13.1672C11.4998 13.0751 11.5744 13.0004 11.6665 13.0004H12.3335C12.4255 13.0004 12.5002 13.0751 12.5002 13.1672V13.1672C12.5002 13.4434 12.2762 13.6674 12 13.6674Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.0025 13.0004C18.0025 13.5529 18.4504 14.0008 19.0029 14.0008V14.0008C20.108 14.0008 21.0038 13.105 21.0038 11.9999V8.99869C21.0038 7.34114 19.6601 5.99744 18.0025 5.99744H17.5854"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.0496 17.8488L6.99792 21.0038"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.9504 17.8488L17.0021 21.0038"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.41464 5.99744H5.99747C4.33992 5.99744 2.99622 7.34114 2.99622 8.99869V11.9999C2.99622 13.105 3.89202 14.0008 4.99705 14.0008V14.0008C5.54956 14.0008 5.99747 13.5529 5.99747 13.0004"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.0008 17.8315V18.5027C14.0008 19.3315 13.329 20.0034 12.5002 20.0034H11.4998C10.671 20.0034 9.99915 19.3315 9.99915 18.5027V17.8312"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 13.6673V15.0012C12 16.6588 10.6563 18.0025 8.99875 18.0025V18.0025C7.3412 18.0025 5.9975 16.6588 5.9975 15.0012V7.9983C5.9975 5.23572 8.23701 2.99622 10.9996 2.99622H13.0004C15.763 2.99622 18.0025 5.23572 18.0025 7.9983V15.0012C18.0025 16.6588 16.6588 18.0025 15.0012 18.0025V18.0025C13.3437 18.0025 12 16.6588 12 15.0012V13.6673Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.2509 9.49931C14.2507 9.63735 14.1388 9.74915 14.0007 9.74909C13.8627 9.74903 13.7508 9.63714 13.7507 9.49909C13.7507 9.36105 13.8625 9.24906 14.0005 9.24888C14.0669 9.2488 14.1307 9.27516 14.1777 9.32214C14.2247 9.36912 14.251 9.43287 14.2509 9.49931"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.2493 9.49931C10.2491 9.63735 10.1371 9.74915 9.99906 9.74909C9.86102 9.74903 9.74913 9.63714 9.74907 9.49909C9.74901 9.36105 9.86081 9.24906 9.99885 9.24888C10.0653 9.2488 10.129 9.27516 10.176 9.32214C10.223 9.36912 10.2494 9.43287 10.2493 9.49931"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Dog</div>
    </div>
  );
};

export const Breakfast = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.66101 20.1128L5.05562 20.3759C5.66975 20.7853 6.39133 21.0038 7.12942 21.0038H16.8705C17.6086 21.0038 18.3301 20.7853 18.9443 20.3759L19.3389 20.1128C20.379 19.4194 21.0037 18.2521 21.0037 17.0021V17.0021C21.0037 16.4496 20.5558 16.0017 20.0033 16.0017H3.99663C3.44412 16.0017 2.99622 16.4496 2.99622 17.0021V17.0021C2.99622 18.2521 3.62093 19.4194 4.66101 20.1128V20.1128Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.8076 16.0017C19.9348 15.0352 19.3967 14.1039 18.4959 13.7313L18.4506 13.7126C17.9223 13.4941 17.5026 13.0744 17.2841 12.5461L17.2652 12.5005C16.8927 11.5999 15.9615 11.0619 14.9953 11.189L14.9428 11.1959C14.3753 11.2706 13.8013 11.1167 13.3472 10.7681L13.3112 10.7404C12.5382 10.1469 11.4629 10.1469 10.69 10.7404L10.6492 10.7717C10.1966 11.1192 9.6245 11.2726 9.0588 11.1981L9.00477 11.191C8.03835 11.0638 7.10714 11.6022 6.73516 12.5032L6.71703 12.5471C6.49866 13.0761 6.07851 13.4962 5.54955 13.7146L5.50565 13.7327C4.60466 14.1047 4.06626 15.0359 4.19342 16.0023"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.46061 11.5798L3.43893 7.55811C3.05868 7.17953 2.90967 6.62664 3.04817 6.10825C3.18666 5.58985 3.59156 5.18495 4.10996 5.04646C4.62835 4.90796 5.18124 5.05698 5.55982 5.43722L10.792 10.6694"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div>Breakfast</div>
    </div>
  );
};

export const Longterm = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5 3V6"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5 3V6"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="3"
          y="4.5"
          width="18"
          height="16.5"
          rx="3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.32 16H16"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.66 16V11L13.2 12.32"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 11.96C8.15305 11.3968 8.66238 11.0044 9.246 11C9.97446 11 10.565 11.5905 10.565 12.319C10.5648 12.9712 10.0362 13.4998 9.384 13.5C10.0362 13.5002 10.5648 14.0288 10.565 14.681C10.565 15.4095 9.97446 16 9.246 16C8.66238 15.9956 8.15305 15.6032 8 15.04"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div>Longterm</div>
    </div>
  );
};

export const HouseKey = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.7224 7.36308L11.1556 6.9299C12.3281 5.75742 14.2279 5.75742 15.4004 6.9299L19.9152 11.4448C21.3668 12.8964 21.3668 15.2494 19.9152 16.701L19.6941 16.9221C18.2425 18.3737 15.8896 18.3737 14.438 16.9221L10.9235 13.4076"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.49926 14.514C4.02164 13.7757 2.99622 12.264 2.99622 10.4993C2.99622 8.01328 5.01206 5.99744 7.49809 5.99744C9.98413 5.99744 12 8.01328 12 10.4993C12 12.263 10.9755 13.7747 9.49892 14.513V14.511L9.49792 19.0069C9.49692 19.271 9.39188 19.5241 9.2048 19.7101L8.20238 20.7126C7.81222 21.1017 7.18196 21.1007 6.7928 20.7116L5.78938 19.7061C5.6023 19.5191 5.49726 19.265 5.49726 19.0009L5.49926 14.512"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.49811 10.2492V5.74736C7.49811 4.22773 8.72962 2.99622 10.2493 2.99622V2.99622C11.7689 2.99622 13.0004 4.22773 13.0004 5.74736V6.06449"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.49706 10.2492C7.359 10.2492 7.24696 10.3613 7.24896 10.4994C7.24896 10.6374 7.361 10.7495 7.49906 10.7495C7.63712 10.7495 7.74917 10.6374 7.74917 10.4994C7.74817 10.3613 7.63612 10.2492 7.49706 10.2492"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>House key</div>
    </div>
  );
};

export const Userprofile = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.8171 4.16689C16.373 5.72274 16.373 8.24527 14.8171 9.80112C13.2613 11.357 10.7387 11.357 9.18288 9.80112C7.62703 8.24527 7.62703 5.72274 9.18288 4.16689C10.7387 2.61104 13.2613 2.61104 14.8171 4.16689"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 14.0081C16.554 14.0081 21 15.9751 21 19.0001V20.0001C21 20.5521 20.552 21.0001 20 21.0001H4C3.448 21.0001 3 20.5521 3 20.0001V19.0001C3 15.9741 7.446 14.0081 12 14.0081"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div>User</div>
    </div>
  );
};

export const CleaningSprayAction = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.49685 1.99585H12.6128C12.9344 1.99585 13.2364 2.15043 13.4244 2.41131C13.6124 2.67219 13.6636 3.00755 13.5619 3.31263L13.0795 4.75983C13.0297 4.9092 12.9125 5.0264 12.7631 5.07619L10.6832 5.76948C10.2747 5.90565 9.99914 6.28796 9.99914 6.71858V8.58435C9.99914 8.84968 10.1045 9.10414 10.2922 9.29175L13.8292 12.8288C14.5796 13.5792 15.0012 14.5971 15.0012 15.6584V20.0033C15.0012 21.1084 14.1054 22.0042 13.0004 22.0042H5.99748C4.89245 22.0042 3.99664 21.1084 3.99664 20.0033V12.6058C3.99664 12.2108 4.11357 11.8246 4.33268 11.496L5.66144 9.50283C5.88055 9.17415 5.99748 8.78798 5.99748 8.39296V6.82631C5.99748 6.29565 5.78667 5.78673 5.41144 5.4115L4.14315 4.14319C4.04934 4.04939 3.99664 3.92215 3.99664 3.78949V2.49606C3.99664 2.2198 4.22059 1.99585 4.49685 1.99585Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.7141 5.42578L13.0004 7.99832"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.6023 2.19593L17.0021 2.79618"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.0021 5.19715L17.6023 5.7974"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.4031 3.99667H20.0033"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99916 8.99874H5.9975"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div>Cleaning spray</div>
    </div>
  );
};

export const Smoking = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="6.5"
          y="12"
          width="11"
          height="3"
          rx="0.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5 6.5V6.525C13.507 7.3465 14.1785 8.00684 15 8V8C15.8215 7.99316 16.493 8.6535 16.5 9.475V9.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 15V12"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="2.99011"
          y="3"
          width="18"
          height="18"
          rx="5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Smoking</div>
    </div>
  );
};

export const CampFire = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17 9.14306C16.9691 6.75628 15.7623 4.53851 13.775 3.21631C13.3914 2.94511 12.8823 2.9313 12.4845 3.1813C12.0868 3.4313 11.8785 3.89603 11.9565 4.35931C12.106 5.33746 11.8668 6.3353 11.29 7.13931C10.8173 6.71824 10.4546 6.18801 10.2336 5.59479C10.1638 5.37255 9.99539 5.19493 9.77719 5.11332C9.559 5.03171 9.31537 5.05523 9.11681 5.17707C7.61246 6.19081 6.80876 7.96653 7.03994 9.76578C7.44076 12.3218 9.72142 14.1525 12.3036 13.9911C14.8858 13.8297 16.9207 11.7291 17 9.14306Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 21L21 15"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 16.4117L4 15"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17 19.5883L21 21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div>Camp fire</div>
    </div>
  );
};

export const WomenStaff = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.99622 21.0037V20.6195C2.99622 19.1887 4.00613 17.9568 5.40922 17.6763L8.25641 17.1071C8.49165 17.06 8.73597 17.1082 8.93569 17.2411V17.2411C10.7911 18.4787 13.2088 18.4787 15.0642 17.2411V17.2411C15.264 17.1082 15.5083 17.06 15.7435 17.1071L18.5907 17.6763C19.9938 17.9568 21.0037 19.1887 21.0037 20.6195V21.0037"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.6401 14.0008H17.0021C17.8309 14.0008 18.5027 13.329 18.5027 12.5002V8.49856C18.5027 4.90721 15.5914 1.99585 12 1.99585V1.99585C8.40868 1.99585 5.49731 4.90721 5.49731 8.49856V12.5002C5.49731 13.329 6.16917 14.0008 6.99794 14.0008H9.35992"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.99919 6.6167H14.0009C15.1059 6.6167 16.0017 7.5125 16.0017 8.61753V10.9995C16.0017 13.2096 14.2101 15.0012 12 15.0012V15.0012C9.78996 15.0012 7.99835 13.2096 7.99835 10.9995V8.61753C7.99835 7.5125 8.89416 6.6167 9.99919 6.6167Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.99792 21.0037H17.0021"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.0017 21.0038V17.1582"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.99832 21.0038V17.1582"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.1019 14.406L14.8452 17.3792"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.90012 14.406L9.15681 17.3792"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Women staff</div>
    </div>
  );
};

export const Stairs = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 21H17"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21 20V11C21 10.4477 20.5523 10 20 10H16C15.4477 10 15 10.4477 15 11V13H12C11.4477 13 11 13.4477 11 14V16H6C5.44772 16 5 16.4477 5 17V20C5 20.5523 5.44772 21 6 21H20C20.5523 21 21 20.5523 21 20Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.49999 15.9999L7.49989 10.2618"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 10V3.08215"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 3H18.6248C18.2179 3 17.8208 3.12406 17.4863 3.35562L5 12"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Stairs</div>
    </div>
  );
};

export const ManStaff = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 7H8"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 3H14C15.1046 3 16 3.89543 16 5V9C16 11.2091 14.2091 13 12 13V13C9.79086 13 8 11.2091 8 9V5C8 3.89543 8.89543 3 10 3Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 15.5L5.35 16.2297C3.98363 16.5029 3.00004 17.7025 3 19.0959L3 21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.05 17.0001C12.05 17.0277 12.0276 17.05 12 17.05C11.9724 17.05 11.95 17.0276 11.95 17C11.95 16.9724 11.9723 16.95 11.9999 16.95C12.0132 16.95 12.026 16.9553 12.0354 16.9646C12.0447 16.974 12.05 16.9868 12.05 17.0001"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.05 20.0001C12.05 20.0277 12.0276 20.05 12 20.05C11.9724 20.05 11.95 20.0276 11.95 20C11.95 19.9724 11.9723 19.95 11.9999 19.95C12.0132 19.95 12.026 19.9553 12.0354 19.9646C12.0447 19.974 12.05 19.9868 12.05 20.0001"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 15.5L18.65 16.2297C20.0164 16.5029 21 17.7025 21 19.0959V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Man staff</div>
    </div>
  );
};
